<template>
  <div class="main-contain">
    <div class="title">
      <el-breadcrumb>
        <el-breadcrumb-item>店铺交易配置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main01">
      <div class="main-tip">
        <h4>承诺提示</h4>
        <p>1、平台开启的自动化配置，商户不可关闭</p>
        <p>2、平台未开启的自动化配置，商户可自行选择是否开启。</p>
        <p>3、平台自动化设置的时间，商户需设置在该时间段内，不可超出。</p>
        <p>4、商户先行开启，平台后开启，按对用户体验最优自动选择。</p>
        <p>5、平台关闭自动化配置，商户未关闭，以商户的设置为准。</p>
        <p>6、平台开启的自动化配置，商户未调整，以平台配置为准。</p>
      </div>
      <div class="main-table">
        <el-table :data="configList"
                  border
                  :show-header="false">
          <el-table-column width="180"
                           align="center"
                           :show-overflow-tooltip="true"
                           prop="title">
          </el-table-column>
          <el-table-column width="180"
                           align="center"
                           :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.flag"
                         active-color="#13ce66"
                         inactive-color="#ff4949">
              </el-switch>
            </template>

          </el-table-column>
          <el-table-column align="left">
            <template slot-scope="scope">
              <div v-if="scope.row.id==43||scope.row.id==44||scope.row.id==45||scope.row.id==46">
                <span>{{scope.row.message}} </span>

              </div>
              <div v-else>
                <span>{{scope.row.message.slice(0,4) }}&nbsp;&nbsp; </span>
                <el-input v-model="scope.row.configure" type="number"
                          style="width:100px"></el-input>&nbsp;&nbsp;
                <span>{{scope.row.message.slice(4) }}&nbsp;&nbsp; </span>
              </div>

            </template>
          </el-table-column>

        </el-table>
         <div class="main-fixed" v-if="configList.length>0">
    <el-button type="primary" @click="save" :loading="loading">保 存</el-button> (保存后生效)
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: {

  },
  data () {
    return {
      configList: [],
      loading:false

    };
  },
  mounted () {
    this.getConfigList()
  },
  computed: {
    ...mapGetters(["getToken"]),
  },
  methods: {
    ...mapActions({
      configListApi: "newshop/configList",
      setConfigList: "newshop/setConfigList",
    }),
    save(){
      let obj = {}
      this.configList.map(el => {
        let objValue = {
          "status": el.flag == true ? 1 : 2,
          "value": el.configure,
          "unit": el.unit
        }
        obj[el.code] = objValue
      })
      this.setConfigUpdate(obj)
    },
    getConfigList () {
      this.listLoading = true;
      const data = {
        token: this.getToken,
      }
      this.configListApi(data).then(res => {
        this.listLoading = false;
        if (res.code == 1) {
          this.configList = res.data.map(el => {
            el.status == 1 ? el.flag = true : el.flag = false
            if (el.admin_status==1) {
               return el
            }
           
          });
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    setConfigUpdate(data) {
      this.loading = true;
      data.token = this.getToken
        this.setConfigList(data).then(res => {
          this.loading = false;
          if (res.code == 1) {
            this.getConfigList()
          } else {
            this.$message.error(res.msg)
          }
        }).catch(err=>{
           this.$message.error(err)
        })
    },
  },
  components: {

  },
};
</script>

<style scoped lang="scss">
.main-tip {
  padding: 10px;
  background: rgb(106, 246, 242);
  border-radius: 10px;

  p {
    padding-top: 10px;
  }
}
.main-table {
  padding: 20px 0;

}
.main-fixed {
   // text-align: right;
    height: 40px;
    padding: 10px 20px;
  }

::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
-webkit-appearance: none !important;
}
::v-deep input[type='number'] {
-moz-appearance: textfield !important;
}

</style>
